export default "__VITE_ASSET__BzYVcY4S__"